import React from "react";

import { readOnlyValue } from "../../attributes/lib/attribute-data";

export const buildAttributeItems = (id, attributes, attributeList) => {
    return attributeList.map((attr) => {
        const useAttr = attributes[attr.uuid];
        const value = useAttr ? readOnlyValue(useAttr.value, attr.componentType, attr) : "";

        return <li key={`${id}_${attr.uuid}`}>{value}</li>;
    });
};
